






import { Component, Vue } from 'vue-property-decorator';
import { RemoteEduMenu } from '@/pages/profile/modules';

@Component({
  components: {
    RemoteEduMenu,
  },
})
export default class Education extends Vue {}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/views/education/Education.vue